import moveLoanWriteOff from "@/api/credit-operation/move-loan-write-off";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    loanWriteOffs: [],
    branches: [],
    employeesByBranch: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_LOAN_WRITE_OFFS(state, data) {
        state.loanWriteOffs = data;
    },
    SET_BRANCHES(state, data) {
        state.branches = data;
    },
    SET_EMPLOYEES_BY_BRANCH(state, data) {
        state.employeesByBranch = data;
    },
    CLEAR_RESOURCES(state) {
        state.loanWriteOffs = [];
        state.employeesByBranch = [];
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                search: context.state.search
            },
            attributes
        );
        // Strip empty values so blank filters don't appear as ?from_branch_id=&...
        Object.keys(params).forEach(k => {
            if (params[k] === "" || params[k] === null || params[k] === undefined) {
                delete params[k];
            }
        });
        return moveLoanWriteOff.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return moveLoanWriteOff.store(data);
    },
    async getLoanWriteOffs(context, attributes = {}) {
        const params = Object.assign(
            { search: attributes.search, branch_id: attributes.branch_id },
            attributes
        );
        const response = await moveLoanWriteOff.loanWriteOff({ params });
        context.commit("SET_LOAN_WRITE_OFFS", response.data);
        return response;
    },
    async getBranches(context) {
        const response = await moveLoanWriteOff.branches();
        context.commit("SET_BRANCHES", response.data);
        return response;
    },
    async getEmployeesByBranch(context, { branch_id }) {
        if (!branch_id) {
            context.commit("SET_EMPLOYEES_BY_BRANCH", []);
            return;
        }
        const response = await moveLoanWriteOff.employeesByBranch({
            params: { branch_id }
        });
        context.commit("SET_EMPLOYEES_BY_BRANCH", response.data);
        return response;
    }
};
